import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { createSlice } from "@reduxjs/toolkit";
var initialState = {
    data: null,
    isFetching: false,
    isError: false,
    requestKey: ""
};
var allCatalogSlice = createSlice({
    name: "allCatalog",
    initialState: initialState,
    reducers: {
        fetchData: function(state, action) {
            state.isFetching = true;
            state.data = null;
            state.isError = false;
            state.requestKey = action.payload || "";
        },
        fetchDataSuccess: function(state, action) {
            var _action_payload, _action_payload1;
            var payload = ((_action_payload = action.payload) === null || _action_payload === void 0 ? void 0 : _action_payload.data) !== undefined ? action.payload.data : action.payload;
            var _action_payload_requestKey;
            var requestKey = (_action_payload_requestKey = (_action_payload1 = action.payload) === null || _action_payload1 === void 0 ? void 0 : _action_payload1.requestKey) !== null && _action_payload_requestKey !== void 0 ? _action_payload_requestKey : state.requestKey;
            return _object_spread_props(_object_spread({}, state), {
                isFetching: false,
                data: payload,
                requestKey: requestKey
            });
        },
        fetchDataFailure: function(state) {
            return _object_spread_props(_object_spread({}, state), {
                isFetching: false,
                isError: true
            });
        },
        resetState: function() {
            return initialState;
        }
    }
});
var _allCatalogSlice_actions = allCatalogSlice.actions;
export var fetchData = _allCatalogSlice_actions.fetchData, fetchDataSuccess = _allCatalogSlice_actions.fetchDataSuccess, fetchDataFailure = _allCatalogSlice_actions.fetchDataFailure, resetState = _allCatalogSlice_actions.resetState;
export default allCatalogSlice.reducer;
